import type Importance from "owa-service/lib/contract/Importance";

export function getImportanceSortRank(importance: string | null | undefined): Importance {
    return importance === "High"
        ? 2 : importance === "Low"
        ? 0 : 1;
}

/** The input is newest first, so the stable sort keeps that tie-break within each importance. */
export default function sortRowsByImportance<T>(rows: readonly T[], getImportance: (row: T) => string | null | undefined, ascending: boolean): T[] {
    const direction = ascending ? 1 : -1;
    return rows
        .map(row => ({ row, rank: getImportanceSortRank(getImportance(row)) }))
        .sort((a, b) => direction * (a.rank - b.rank))
        .map(({ row }) => row);
}
